import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "mt-16" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-primary text-caption",
  href: "/document/",
  target: "_blank"
}, "เอกสารนักพัฒนา", -1)

import { defineComponent, reactive, ref, type Ref } from 'vue';
import NProgress from '../../utils/nprogress';
import cwTextLogo from '../TextLogo.vue';
import api from '../../apis/api';
import config from '../../config';
import sessionStorage from '../../repository/session-storage';
import { state as stateSnackbar } from '../../store/state-snackbar';
import { delay } from '../../utils/util';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  props: {
  loginCallback: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props;

if (config.useMockApi) api.mock();

defineComponent({ name: 'CwLogin' });



const formLogin = ref();
const usernameRules = reactive([(v: string) => !!v || 'Username is required']);
const passwordRules = reactive([(v: string) => !!v || 'Password is required']);
const username: Ref<string> = ref('');
const password: Ref<string> = ref('');
const showPassword: Ref<boolean> = ref(false);
const loadingLogin: Ref<boolean> = ref(false);

const login = async (user: string, pass: string) => {
  try {
    loadingLogin.value = true;
    const result = await api.login(user, pass);

    NProgress.start();
    await delay(1000);
    stateSnackbar.show({
      text: 'เข้าสู่ระบบสำเร็จ',
      color: 'primary',
      // props: { timeout: 1000 },
    });
    loadingLogin.value = false;
    props.loginCallback(result);

    sessionStorage.setLoginInfo(result);
  } catch (error: any) {
    loadingLogin.value = false;
    stateSnackbar.show({
      text: error?.response?.data?.errorMessage ?? 'เกิดความผิดพลาด',
      color: 'error',
    });
  }
  NProgress.done();
};

const validate = async () => {
  const { valid } = await formLogin.value.validate();
  if (valid) {
    login(username.value, password.value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, { "full-height": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createVNode(cwTextLogo)
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_form, {
                    ref_key: "formLogin",
                    ref: formLogin
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: username.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                        placeholder: "Username",
                        "bg-color": "grey-lighten-4",
                        rules: usernameRules,
                        variant: "solo",
                        "single-line": ""
                      }, {
                        "prepend-inner": _withCtx(() => [
                          _createVNode(_component_v_icon, { icon: "mdi mdi-account" }),
                          _createVNode(_component_v_divider, {
                            class: "mx-1",
                            vertical: "",
                            length: "25px"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "rules"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                        placeholder: "Password",
                        "single-line": "",
                        type: showPassword.value ? 'text' : 'password',
                        "bg-color": "grey-lighten-4",
                        color: "grey-lighten-4",
                        rules: passwordRules,
                        variant: "solo"
                      }, {
                        "prepend-inner": _withCtx(() => [
                          _createVNode(_component_v_icon, { icon: "mdi mdi-lock-outline" }),
                          _createVNode(_component_v_divider, {
                            class: "mx-1",
                            vertical: "",
                            length: "25px"
                          })
                        ]),
                        "append-inner": _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: showPassword.value ? 'mdi-eye-off' : 'mdi-eye',
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value))
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "type", "rules"])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_row, {
                    justify: "center",
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            loading: loadingLogin.value,
                            block: "",
                            rounded: "pill",
                            color: "primary",
                            onClick: validate
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" เข้าสู่ระบบ ")
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, {
                    class: "mt-10",
                    justify: "center",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})